var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.dataForm.id ? 'Edit Tag' : 'Add Tag',
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tag Name",
      "prop": "tagName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.tagName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "tagName", $$v);
      },
      expression: "dataForm.tagName"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Remark",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "autosize": {
        minRows: 4
      },
      "resize": "none",
      "placeholder": "Remark"
    },
    model: {
      value: _vm.dataForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "remark", $$v);
      },
      expression: "dataForm.remark"
    }
  })], 1)], 1), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }